import { List, ListItem, ListItemText, Typography } from "@mui/material";

import { useClasses } from "./SearchBarMachinesList.style";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { useReduxState } from "../../../../explorer/redux/hooks";
import { Machine } from "../../../../explorer/types/SpareParts";
import { reduxStoreConfig } from "../../../configuration/reduxStoreConfig";
import { AppIconsDocument, AppIconsMaintenance, AppIconsEmergency } from "../../AppIcons";
import GoToPage from "../../GoToPage/GoToPage";

type THomePageSearchBarMachines = {
    machines?: Machine[];
    setOpen: (open: boolean) => void;
    handleResultClickMachine:any;
};

const SearchBarMachinesList = (props: THomePageSearchBarMachines) => {
    const classes = useClasses();
    const [_, setCurrentMachine] = useReduxState<Machine>(
        reduxStoreConfig.sparePartsCurrentMachine
    );
    
    const { t } = useTranslation();

    

    return (
        <List sx={classes.listResults}>
            {props.machines &&
                props.machines.map((mach, mapIndex) => (
                    <ListItem
                        key={"machine_key_" + mapIndex}
                        sx={classes.listItem}
                        onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            props.handleResultClickMachine(mach);
                        }}
                    >
                        <ListItemText
                            disableTypography
                            primary={
                                <Typography
                                    color="primary"
                                    variant="h6"
                                    component="p"
                                >
                                    {`${mach.serialNumber} ${mach.description}`}
                                </Typography>
                            }
                            secondary={
                                <Typography
                                    variant="body2"
                                    component="p"
                                    sx={classes.listItemTextSecondary}
                                >
                                    {`${mach.customerSiteCode} ${mach.customerSiteName}`}
                                </Typography>
                            }
                        />

                        {mach.hasDocument && (
                            <GoToPage
                                tooltipTitle={t(
                                    "common.spareparts.thecnicalDoc"
                                )}
                                params={{
                                    customerSiteCode: mach.customerSiteCode!,
                                    machineId: mach.id!.toString(),
                                    tabIndex: "TechnicalDocumentation",
                                }}
                                page={"spareparts.machineMore"}
                                onClick={(event: any) => {
                                    setCurrentMachine(mach);
                                    event.stopPropagation();
                                }}
                                children={<AppIconsDocument />}
                            />
                        )}
                        {mach.hasMaintList && (
                            <GoToPage
                                tooltipTitle={t("common.spareparts.maintList")}
                                params={{
                                    customerSiteCode: mach.customerSiteCode!,
                                    machineId: mach.id!.toString(),
                                    tabIndex: "MaintenanceList",
                                }}
                                page={"spareparts.machineMore"}
                                onClick={(event: any) => {
                                    setCurrentMachine(mach);
                                    event.stopPropagation();
                                }}
                                children={<AppIconsMaintenance />}
                            />
                        )}
                        {mach.hasEmergList && (
                            <GoToPage
                                tooltipTitle={t("common.spareparts.emergList")}
                                params={{
                                    customerSiteCode: mach.customerSiteCode!,
                                    machineId: mach.id!.toString(),
                                    tabIndex: "EmergencyList",
                                }}
                                page={"spareparts.machineMore"}
                                onClick={(event: any) => {
                                    setCurrentMachine(mach);
                                    event.stopPropagation();
                                }}
                                children={<AppIconsEmergency />}
                            />
                        )}
                    </ListItem>
                ))}
        </List>
    );
};

export default SearchBarMachinesList;
